import { Chip } from '@mui/material';

interface DocumentStatusProps {
  title: string;
  value: string;
  removeSearchParam: () => void;
}

const DocumentFilterOption = ({ title, value, removeSearchParam }: DocumentStatusProps) => {
  if (!value) return null;

  return (
    <Chip
      key={`chip-docfilter-key=-${title}`}
      id={`chip-docfilter-id-${title}`}
      data-cy={`chip-docfilter-${title}-${value}`}
      label={`${title}: ${value}`}
      style={{ margin: '0.25em 0.5em' }}
      onDelete={async () => {
        removeSearchParam();
      }}
    />
  );
};

export default DocumentFilterOption;
